__turbopack_context__.v({
  "company-card": "uZ0kpG_company-card",
  "error-message": "uZ0kpG_error-message",
  "filters": "uZ0kpG_filters",
  "filters__form": "uZ0kpG_filters__form",
  "listing-page-content": "uZ0kpG_listing-page-content",
  "no-results-message": "uZ0kpG_no-results-message",
  "table-loader": "uZ0kpG_table-loader",
});
